// extracted by mini-css-extract-plugin
export default {"error":"Error_error__pKTpe","info":"Error_info__s64dd","spinner":"Error_spinner__H3D-d","text":"Error_text__4P6MB","button":"Error_button__WwLRL"};